<button [type]="type" [class]="getClasses()" [disabled]="disabled">
    <span><ng-content></ng-content></span>
    <div *ngIf="icon && !isLoading" class="btn-icon">
        <app-icon [name]="icon" [size]="iconSize" [type]="iconType"></app-icon>
    </div>
    <div *ngIf="isLoading" class="btn-icon btn-loader">
        <app-loader [isLoading]="isLoading" [size]="iconSize"></app-loader>
    </div>
</button>